var _typeof4 = require("/Users/kishansheth/Pictures/Design/Sites/Personal/Gatsby/react-site/node_modules/@babel/runtime/helpers/typeof");

module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        /******/
        configurable: false,

        /******/
        enumerable: true,

        /******/
        get: getter
        /******/

      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 49);
  /******/
}(
/************************************************************************/

/******/
[
/* 0 */

/***/
function (module, exports) {
  var core = module.exports = {
    version: '2.4.0'
  };
  if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

  /***/
},
/* 1 */

/***/
function (module, exports) {
  // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
  var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
  if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

  /***/
},
/* 2 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1),
      core = __webpack_require__(0),
      ctx = __webpack_require__(35),
      hide = __webpack_require__(8),
      PROTOTYPE = 'prototype';

  var $export = function $export(type, name, source) {
    var IS_FORCED = type & $export.F,
        IS_GLOBAL = type & $export.G,
        IS_STATIC = type & $export.S,
        IS_PROTO = type & $export.P,
        IS_BIND = type & $export.B,
        IS_WRAP = type & $export.W,
        exports = IS_GLOBAL ? core : core[name] || (core[name] = {}),
        expProto = exports[PROTOTYPE],
        target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE],
        key,
        own,
        out;
    if (IS_GLOBAL) source = name;

    for (key in source) {
      // contains in native
      own = !IS_FORCED && target && target[key] !== undefined;
      if (own && key in exports) continue; // export native or passed

      out = own ? target[key] : source[key]; // prevent global pollution for namespaces

      exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] // bind timers to global for call from export context
      : IS_BIND && own ? ctx(out, global) // wrap global constructors for prevent change them in library
      : IS_WRAP && target[key] == out ? function (C) {
        var F = function F(a, b, c) {
          if (this instanceof C) {
            switch (arguments.length) {
              case 0:
                return new C();

              case 1:
                return new C(a);

              case 2:
                return new C(a, b);
            }

            return new C(a, b, c);
          }

          return C.apply(this, arguments);
        };

        F[PROTOTYPE] = C[PROTOTYPE];
        return F; // make static versions for prototype methods
      }(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out; // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%

      if (IS_PROTO) {
        (exports.virtual || (exports.virtual = {}))[key] = out; // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%

        if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
      }
    }
  }; // type bitmap


  $export.F = 1; // forced

  $export.G = 2; // global

  $export.S = 4; // static

  $export.P = 8; // proto

  $export.B = 16; // bind

  $export.W = 32; // wrap

  $export.U = 64; // safe

  $export.R = 128; // real proto method for `library` 

  module.exports = $export;
  /***/
},
/* 3 */

/***/
function (module, exports, __webpack_require__) {
  var anObject = __webpack_require__(11),
      IE8_DOM_DEFINE = __webpack_require__(36),
      toPrimitive = __webpack_require__(17),
      dP = Object.defineProperty;

  exports.f = __webpack_require__(4) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    anObject(O);
    P = toPrimitive(P, true);
    anObject(Attributes);
    if (IE8_DOM_DEFINE) try {
      return dP(O, P, Attributes);
    } catch (e) {
      /* empty */
    }
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
  };
  /***/
},
/* 4 */

/***/
function (module, exports, __webpack_require__) {
  // Thank's IE8 for his funny defineProperty
  module.exports = !__webpack_require__(9)(function () {
    return Object.defineProperty({}, 'a', {
      get: function get() {
        return 7;
      }
    }).a != 7;
  });
  /***/
},
/* 5 */

/***/
function (module, exports) {
  var hasOwnProperty = {}.hasOwnProperty;

  module.exports = function (it, key) {
    return hasOwnProperty.call(it, key);
  };
  /***/

},
/* 6 */

/***/
function (module, exports, __webpack_require__) {
  // to indexed object, toObject with fallback for non-array-like ES3 strings
  var IObject = __webpack_require__(39),
      defined = __webpack_require__(18);

  module.exports = function (it) {
    return IObject(defined(it));
  };
  /***/

},
/* 7 */

/***/
function (module, exports) {
  // shim for using process in browser
  var process = module.exports = {}; // cached from whatever global is present so that test runners that stub it
  // don't break things.  But we need to wrap it in a try catch in case it is
  // wrapped in strict mode code which doesn't define any globals.  It's inside a
  // function because try/catches deoptimize in certain engines.

  var cachedSetTimeout;
  var cachedClearTimeout;

  function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
  }

  function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
  }

  (function () {
    try {
      if (typeof setTimeout === 'function') {
        cachedSetTimeout = setTimeout;
      } else {
        cachedSetTimeout = defaultSetTimout;
      }
    } catch (e) {
      cachedSetTimeout = defaultSetTimout;
    }

    try {
      if (typeof clearTimeout === 'function') {
        cachedClearTimeout = clearTimeout;
      } else {
        cachedClearTimeout = defaultClearTimeout;
      }
    } catch (e) {
      cachedClearTimeout = defaultClearTimeout;
    }
  })();

  function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
      //normal enviroments in sane situations
      return setTimeout(fun, 0);
    } // if setTimeout wasn't available but was latter defined


    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
      cachedSetTimeout = setTimeout;
      return setTimeout(fun, 0);
    }

    try {
      // when when somebody has screwed with setTimeout but no I.E. maddness
      return cachedSetTimeout(fun, 0);
    } catch (e) {
      try {
        // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
        return cachedSetTimeout.call(null, fun, 0);
      } catch (e) {
        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
        return cachedSetTimeout.call(this, fun, 0);
      }
    }
  }

  function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
      //normal enviroments in sane situations
      return clearTimeout(marker);
    } // if clearTimeout wasn't available but was latter defined


    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
      cachedClearTimeout = clearTimeout;
      return clearTimeout(marker);
    }

    try {
      // when when somebody has screwed with setTimeout but no I.E. maddness
      return cachedClearTimeout(marker);
    } catch (e) {
      try {
        // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
        return cachedClearTimeout.call(null, marker);
      } catch (e) {
        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
        // Some versions of I.E. have different rules for clearTimeout vs setTimeout
        return cachedClearTimeout.call(this, marker);
      }
    }
  }

  var queue = [];
  var draining = false;
  var currentQueue;
  var queueIndex = -1;

  function cleanUpNextTick() {
    if (!draining || !currentQueue) {
      return;
    }

    draining = false;

    if (currentQueue.length) {
      queue = currentQueue.concat(queue);
    } else {
      queueIndex = -1;
    }

    if (queue.length) {
      drainQueue();
    }
  }

  function drainQueue() {
    if (draining) {
      return;
    }

    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;

    while (len) {
      currentQueue = queue;
      queue = [];

      while (++queueIndex < len) {
        if (currentQueue) {
          currentQueue[queueIndex].run();
        }
      }

      queueIndex = -1;
      len = queue.length;
    }

    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
  }

  process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);

    if (arguments.length > 1) {
      for (var i = 1; i < arguments.length; i++) {
        args[i - 1] = arguments[i];
      }
    }

    queue.push(new Item(fun, args));

    if (queue.length === 1 && !draining) {
      runTimeout(drainQueue);
    }
  }; // v8 likes predictible objects


  function Item(fun, array) {
    this.fun = fun;
    this.array = array;
  }

  Item.prototype.run = function () {
    this.fun.apply(null, this.array);
  };

  process.title = 'browser';
  process.browser = true;
  process.env = {};
  process.argv = [];
  process.version = ''; // empty string to avoid regexp issues

  process.versions = {};

  function noop() {}

  process.on = noop;
  process.addListener = noop;
  process.once = noop;
  process.off = noop;
  process.removeListener = noop;
  process.removeAllListeners = noop;
  process.emit = noop;
  process.prependListener = noop;
  process.prependOnceListener = noop;

  process.listeners = function (name) {
    return [];
  };

  process.binding = function (name) {
    throw new Error('process.binding is not supported');
  };

  process.cwd = function () {
    return '/';
  };

  process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
  };

  process.umask = function () {
    return 0;
  };
  /***/

},
/* 8 */

/***/
function (module, exports, __webpack_require__) {
  var dP = __webpack_require__(3),
      createDesc = __webpack_require__(14);

  module.exports = __webpack_require__(4) ? function (object, key, value) {
    return dP.f(object, key, createDesc(1, value));
  } : function (object, key, value) {
    object[key] = value;
    return object;
  };
  /***/
},
/* 9 */

/***/
function (module, exports) {
  module.exports = function (exec) {
    try {
      return !!exec();
    } catch (e) {
      return true;
    }
  };
  /***/

},
/* 10 */

/***/
function (module, exports, __webpack_require__) {
  var store = __webpack_require__(21)('wks'),
      uid = __webpack_require__(15),
      _Symbol = __webpack_require__(1).Symbol,
      USE_SYMBOL = typeof _Symbol == 'function';

  var $exports = module.exports = function (name) {
    return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)('Symbol.' + name));
  };

  $exports.store = store;
  /***/
},
/* 11 */

/***/
function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(12);

  module.exports = function (it) {
    if (!isObject(it)) throw TypeError(it + ' is not an object!');
    return it;
  };
  /***/

},
/* 12 */

/***/
function (module, exports) {
  module.exports = function (it) {
    return _typeof4(it) === 'object' ? it !== null : typeof it === 'function';
  };
  /***/

},
/* 13 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.14 / 15.2.3.14 Object.keys(O)
  var $keys = __webpack_require__(38),
      enumBugKeys = __webpack_require__(22);

  module.exports = Object.keys || function keys(O) {
    return $keys(O, enumBugKeys);
  };
  /***/

},
/* 14 */

/***/
function (module, exports) {
  module.exports = function (bitmap, value) {
    return {
      enumerable: !(bitmap & 1),
      configurable: !(bitmap & 2),
      writable: !(bitmap & 4),
      value: value
    };
  };
  /***/

},
/* 15 */

/***/
function (module, exports) {
  var id = 0,
      px = Math.random();

  module.exports = function (key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
  };
  /***/

},
/* 16 */

/***/
function (module, exports) {
  exports.f = {}.propertyIsEnumerable;
  /***/
},
/* 17 */

/***/
function (module, exports, __webpack_require__) {
  // 7.1.1 ToPrimitive(input [, PreferredType])
  var isObject = __webpack_require__(12); // instead of the ES6 spec version, we didn't implement @@toPrimitive case
  // and the second argument - flag - preferred type is a string


  module.exports = function (it, S) {
    if (!isObject(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
  };
  /***/

},
/* 18 */

/***/
function (module, exports) {
  // 7.2.1 RequireObjectCoercible(argument)
  module.exports = function (it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
  };
  /***/

},
/* 19 */

/***/
function (module, exports) {
  // 7.1.4 ToInteger
  var ceil = Math.ceil,
      floor = Math.floor;

  module.exports = function (it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
  };
  /***/

},
/* 20 */

/***/
function (module, exports, __webpack_require__) {
  var shared = __webpack_require__(21)('keys'),
      uid = __webpack_require__(15);

  module.exports = function (key) {
    return shared[key] || (shared[key] = uid(key));
  };
  /***/

},
/* 21 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1),
      SHARED = '__core-js_shared__',
      store = global[SHARED] || (global[SHARED] = {});

  module.exports = function (key) {
    return store[key] || (store[key] = {});
  };
  /***/

},
/* 22 */

/***/
function (module, exports) {
  // IE 8- don't enum bug keys
  module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');
  /***/
},
/* 23 */

/***/
function (module, exports) {
  exports.f = Object.getOwnPropertySymbols;
  /***/
},
/* 24 */

/***/
function (module, exports, __webpack_require__) {
  // 7.1.13 ToObject(argument)
  var defined = __webpack_require__(18);

  module.exports = function (it) {
    return Object(defined(it));
  };
  /***/

},
/* 25 */

/***/
function (module, exports) {
  module.exports = true;
  /***/
},
/* 26 */

/***/
function (module, exports) {
  module.exports = {};
  /***/
},
/* 27 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
  var anObject = __webpack_require__(11),
      dPs = __webpack_require__(73),
      enumBugKeys = __webpack_require__(22),
      IE_PROTO = __webpack_require__(20)('IE_PROTO'),
      Empty = function Empty() {
    /* empty */
  },
      PROTOTYPE = 'prototype'; // Create object with fake `null` prototype: use iframe Object with cleared prototype


  var _createDict = function createDict() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = __webpack_require__(37)('iframe'),
        i = enumBugKeys.length,
        lt = '<',
        gt = '>',
        iframeDocument;

    iframe.style.display = 'none';

    __webpack_require__(74).appendChild(iframe);

    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);

    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    _createDict = iframeDocument.F;

    while (i--) {
      delete _createDict[PROTOTYPE][enumBugKeys[i]];
    }

    return _createDict();
  };

  module.exports = Object.create || function create(O, Properties) {
    var result;

    if (O !== null) {
      Empty[PROTOTYPE] = anObject(O);
      result = new Empty();
      Empty[PROTOTYPE] = null; // add "__proto__" for Object.getPrototypeOf polyfill

      result[IE_PROTO] = O;
    } else result = _createDict();

    return Properties === undefined ? result : dPs(result, Properties);
  };
  /***/

},
/* 28 */

/***/
function (module, exports, __webpack_require__) {
  var def = __webpack_require__(3).f,
      has = __webpack_require__(5),
      TAG = __webpack_require__(10)('toStringTag');

  module.exports = function (it, tag, stat) {
    if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
      configurable: true,
      value: tag
    });
  };
  /***/

},
/* 29 */

/***/
function (module, exports, __webpack_require__) {
  exports.f = __webpack_require__(10);
  /***/
},
/* 30 */

/***/
function (module, exports, __webpack_require__) {
  var global = __webpack_require__(1),
      core = __webpack_require__(0),
      LIBRARY = __webpack_require__(25),
      wksExt = __webpack_require__(29),
      defineProperty = __webpack_require__(3).f;

  module.exports = function (name) {
    var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
    if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, {
      value: wksExt.f(name)
    });
  };
  /***/

},
/* 31 */

/***/
function (module, exports) {
  module.exports = require("react");
  /***/
},
/* 32 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   * All rights reserved.
   *
   * This source code is licensed under the BSD-style license found in the
   * LICENSE file in the root directory of this source tree. An additional grant
   * of patent rights can be found in the PATENTS file in the same directory.
   *
   * 
   */

  function makeEmptyFunction(arg) {
    return function () {
      return arg;
    };
  }
  /**
   * This function accepts and discards inputs; it has no side effects. This is
   * primarily useful idiomatically for overridable function endpoints which
   * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
   */


  var emptyFunction = function emptyFunction() {};

  emptyFunction.thatReturns = makeEmptyFunction;
  emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
  emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
  emptyFunction.thatReturnsNull = makeEmptyFunction(null);

  emptyFunction.thatReturnsThis = function () {
    return this;
  };

  emptyFunction.thatReturnsArgument = function (arg) {
    return arg;
  };

  module.exports = emptyFunction;
  /***/
},
/* 33 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /**
    * Copyright (c) 2013-present, Facebook, Inc.
    * All rights reserved.
    *
    * This source code is licensed under the BSD-style license found in the
    * LICENSE file in the root directory of this source tree. An additional grant
    * of patent rights can be found in the PATENTS file in the same directory.
    *
    */

    /**
     * Use invariant() to assert state which your program assumes to be true.
     *
     * Provide sprintf-style format (only %s is supported) and arguments
     * to provide information about what broke and what you were
     * expecting.
     *
     * The invariant message will be stripped in production, but the invariant
     * will remain to ensure logic does not differ in production.
     */
    var validateFormat = function validateFormat(format) {};

    if (process.env.NODE_ENV !== 'production') {
      validateFormat = function validateFormat(format) {
        if (format === undefined) {
          throw new Error('invariant requires an error message argument');
        }
      };
    }

    function invariant(condition, format, a, b, c, d, e, f) {
      validateFormat(format);

      if (!condition) {
        var error;

        if (format === undefined) {
          error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
        } else {
          var args = [a, b, c, d, e, f];
          var argIndex = 0;
          error = new Error(format.replace(/%s/g, function () {
            return args[argIndex++];
          }));
          error.name = 'Invariant Violation';
        }

        error.framesToPop = 1; // we don't care about invariant's own frame

        throw error;
      }
    }

    module.exports = invariant;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(7));
  /***/
},
/* 34 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Copyright 2013-present, Facebook, Inc.
   * All rights reserved.
   *
   * This source code is licensed under the BSD-style license found in the
   * LICENSE file in the root directory of this source tree. An additional grant
   * of patent rights can be found in the PATENTS file in the same directory.
   */

  var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
  module.exports = ReactPropTypesSecret;
  /***/
},
/* 35 */

/***/
function (module, exports, __webpack_require__) {
  // optional / simple context binding
  var aFunction = __webpack_require__(53);

  module.exports = function (fn, that, length) {
    aFunction(fn);
    if (that === undefined) return fn;

    switch (length) {
      case 1:
        return function (a) {
          return fn.call(that, a);
        };

      case 2:
        return function (a, b) {
          return fn.call(that, a, b);
        };

      case 3:
        return function (a, b, c) {
          return fn.call(that, a, b, c);
        };
    }

    return function ()
    /* ...args */
    {
      return fn.apply(that, arguments);
    };
  };
  /***/

},
/* 36 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = !__webpack_require__(4) && !__webpack_require__(9)(function () {
    return Object.defineProperty(__webpack_require__(37)('div'), 'a', {
      get: function get() {
        return 7;
      }
    }).a != 7;
  });
  /***/
},
/* 37 */

/***/
function (module, exports, __webpack_require__) {
  var isObject = __webpack_require__(12),
      document = __webpack_require__(1).document // in old IE typeof document.createElement is 'object'
  ,
      is = isObject(document) && isObject(document.createElement);

  module.exports = function (it) {
    return is ? document.createElement(it) : {};
  };
  /***/

},
/* 38 */

/***/
function (module, exports, __webpack_require__) {
  var has = __webpack_require__(5),
      toIObject = __webpack_require__(6),
      arrayIndexOf = __webpack_require__(55)(false),
      IE_PROTO = __webpack_require__(20)('IE_PROTO');

  module.exports = function (object, names) {
    var O = toIObject(object),
        i = 0,
        result = [],
        key;

    for (key in O) {
      if (key != IE_PROTO) has(O, key) && result.push(key);
    } // Don't enum bug & hidden keys


    while (names.length > i) {
      if (has(O, key = names[i++])) {
        ~arrayIndexOf(result, key) || result.push(key);
      }
    }

    return result;
  };
  /***/

},
/* 39 */

/***/
function (module, exports, __webpack_require__) {
  // fallback for non-array-like ES3 and non-enumerable old V8 strings
  var cof = __webpack_require__(40);

  module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
    return cof(it) == 'String' ? it.split('') : Object(it);
  };
  /***/
},
/* 40 */

/***/
function (module, exports) {
  var toString = {}.toString;

  module.exports = function (it) {
    return toString.call(it).slice(8, -1);
  };
  /***/

},
/* 41 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
  var has = __webpack_require__(5),
      toObject = __webpack_require__(24),
      IE_PROTO = __webpack_require__(20)('IE_PROTO'),
      ObjectProto = Object.prototype;

  module.exports = Object.getPrototypeOf || function (O) {
    O = toObject(O);
    if (has(O, IE_PROTO)) return O[IE_PROTO];

    if (typeof O.constructor == 'function' && O instanceof O.constructor) {
      return O.constructor.prototype;
    }

    return O instanceof Object ? ObjectProto : null;
  };
  /***/

},
/* 42 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;

  var _iterator = __webpack_require__(68);

  var _iterator2 = _interopRequireDefault(_iterator);

  var _symbol = __webpack_require__(79);

  var _symbol2 = _interopRequireDefault(_symbol);

  var _typeof = typeof _symbol2.default === "function" && _typeof4(_iterator2.default) === "symbol" ? function (obj) {
    return _typeof4(obj);
  } : function (obj) {
    return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : _typeof4(obj);
  };

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof(obj);
  } : function (obj) {
    return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
  };
  /***/
},
/* 43 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var LIBRARY = __webpack_require__(25),
      $export = __webpack_require__(2),
      redefine = __webpack_require__(44),
      hide = __webpack_require__(8),
      has = __webpack_require__(5),
      Iterators = __webpack_require__(26),
      $iterCreate = __webpack_require__(72),
      setToStringTag = __webpack_require__(28),
      getPrototypeOf = __webpack_require__(41),
      ITERATOR = __webpack_require__(10)('iterator'),
      BUGGY = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  ,
      FF_ITERATOR = '@@iterator',
      KEYS = 'keys',
      VALUES = 'values';

  var returnThis = function returnThis() {
    return this;
  };

  module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $iterCreate(Constructor, NAME, next);

    var getMethod = function getMethod(kind) {
      if (!BUGGY && kind in proto) return proto[kind];

      switch (kind) {
        case KEYS:
          return function keys() {
            return new Constructor(this, kind);
          };

        case VALUES:
          return function values() {
            return new Constructor(this, kind);
          };
      }

      return function entries() {
        return new Constructor(this, kind);
      };
    };

    var TAG = NAME + ' Iterator',
        DEF_VALUES = DEFAULT == VALUES,
        VALUES_BUG = false,
        proto = Base.prototype,
        $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT],
        $default = $native || getMethod(DEFAULT),
        $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined,
        $anyNative = NAME == 'Array' ? proto.entries || $native : $native,
        methods,
        key,
        IteratorPrototype; // Fix native

    if ($anyNative) {
      IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));

      if (IteratorPrototype !== Object.prototype) {
        // Set @@toStringTag to native iterators
        setToStringTag(IteratorPrototype, TAG, true); // fix for some old engines

        if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
      }
    } // fix Array#{values, @@iterator}.name in V8 / FF


    if (DEF_VALUES && $native && $native.name !== VALUES) {
      VALUES_BUG = true;

      $default = function values() {
        return $native.call(this);
      };
    } // Define iterator


    if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
      hide(proto, ITERATOR, $default);
    } // Plug for library


    Iterators[NAME] = $default;
    Iterators[TAG] = returnThis;

    if (DEFAULT) {
      methods = {
        values: DEF_VALUES ? $default : getMethod(VALUES),
        keys: IS_SET ? $default : getMethod(KEYS),
        entries: $entries
      };
      if (FORCED) for (key in methods) {
        if (!(key in proto)) redefine(proto, key, methods[key]);
      } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
    }

    return methods;
  };
  /***/

},
/* 44 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__(8);
  /***/
},
/* 45 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
  var $keys = __webpack_require__(38),
      hiddenKeys = __webpack_require__(22).concat('length', 'prototype');

  exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $keys(O, hiddenKeys);
  };
  /***/

},
/* 46 */

/***/
function (module, exports, __webpack_require__) {
  var pIE = __webpack_require__(16),
      createDesc = __webpack_require__(14),
      toIObject = __webpack_require__(6),
      toPrimitive = __webpack_require__(17),
      has = __webpack_require__(5),
      IE8_DOM_DEFINE = __webpack_require__(36),
      gOPD = Object.getOwnPropertyDescriptor;

  exports.f = __webpack_require__(4) ? gOPD : function getOwnPropertyDescriptor(O, P) {
    O = toIObject(O);
    P = toPrimitive(P, true);
    if (IE8_DOM_DEFINE) try {
      return gOPD(O, P);
    } catch (e) {
      /* empty */
    }
    if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
  };
  /***/
},
/* 47 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /**
    * Copyright 2014-2015, Facebook, Inc.
    * All rights reserved.
    *
    * This source code is licensed under the BSD-style license found in the
    * LICENSE file in the root directory of this source tree. An additional grant
    * of patent rights can be found in the PATENTS file in the same directory.
    *
    */
    var emptyFunction = __webpack_require__(32);
    /**
     * Similar to invariant but only logs a warning if the condition is not met.
     * This can be used to log issues in development environments in critical
     * paths. Removing the logging code for production environments will keep the
     * same logic and follow the same code paths.
     */


    var warning = emptyFunction;

    if (process.env.NODE_ENV !== 'production') {
      (function () {
        var printWarning = function printWarning(format) {
          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          var argIndex = 0;
          var message = 'Warning: ' + format.replace(/%s/g, function () {
            return args[argIndex++];
          });

          if (typeof console !== 'undefined') {
            console.error(message);
          }

          try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
          } catch (x) {}
        };

        warning = function warning(condition, format) {
          if (format === undefined) {
            throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
          }

          if (format.indexOf('Failed Composite propType: ') === 0) {
            return; // Ignore CompositeComponent proptype check.
          }

          if (!condition) {
            for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
              args[_key2 - 2] = arguments[_key2];
            }

            printWarning.apply(undefined, [format].concat(args));
          }
        };
      })();
    }

    module.exports = warning;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(7));
  /***/
},
/* 48 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = {
    above: 'above',
    inside: 'inside',
    below: 'below',
    invisible: 'invisible'
  };
  module.exports = exports['default'];
  /***/
},
/* 49 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = undefined;

  var _assign = __webpack_require__(50);

  var _assign2 = _interopRequireDefault(_assign);

  var _getPrototypeOf = __webpack_require__(58);

  var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

  var _classCallCheck2 = __webpack_require__(62);

  var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

  var _createClass2 = __webpack_require__(63);

  var _createClass3 = _interopRequireDefault(_createClass2);

  var _possibleConstructorReturn2 = __webpack_require__(67);

  var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

  var _inherits2 = __webpack_require__(90);

  var _inherits3 = _interopRequireDefault(_inherits2);

  var _react = __webpack_require__(31);

  var _react2 = _interopRequireDefault(_react);

  var _reactWaypoint = __webpack_require__(98);

  var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var ReactLazyBlur = function (_React$Component) {
    (0, _inherits3.default)(ReactLazyBlur, _React$Component);

    function ReactLazyBlur(props) {
      (0, _classCallCheck3.default)(this, ReactLazyBlur);

      var _this = (0, _possibleConstructorReturn3.default)(this, (ReactLazyBlur.__proto__ || (0, _getPrototypeOf2.default)(ReactLazyBlur)).call(this, props));

      _this.state = {
        waypoint: false,
        blur: {},
        background: {},
        loaded: false
      };
      return _this;
    }

    (0, _createClass3.default)(ReactLazyBlur, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        //display blurred image in the place of background before load
        this.setState({
          background: {
            backgroundImage: 'url(' + this.props.blur + ')'
          }
        });
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps, nextState) {
        if (this.state.waypoint !== nextState.waypoint && !nextState.loading && !nextState.loaded) this.lazy();
        return true;
      }
    }, {
      key: 'lazy',
      value: function lazy() {
        var _props = this.props,
            background = _props.background,
            blur = _props.blur;
        var duration = this.props.duration || 500;
        var self = this; //start loading background image

        var img = new Image();

        img.onload = function () {
          //on load, display the background and swap background with blur
          self.setState({
            background: {
              backgroundImage: 'url(' + img.src + ')'
            },
            blur: {
              backgroundImage: 'url(' + blur + ')',
              opacity: 1
            }
          }); //wait for next tick, so opacity from the previous block could be first added to the DOM

          setTimeout(function () {
            //fade out the blurred image by changing the opacity
            self.setState({
              background: {
                backgroundImage: 'url(' + img.src + ')'
              },
              blur: {
                backgroundImage: 'url(' + blur + ')',
                transition: 'opacity',
                transitionDuration: duration / 1000 + 's',
                opacity: 0
              }
            }); //finally remove the blur and its instances

            setTimeout(function () {
              self.setState({
                loaded: true
              });
            }, duration);
          }, 0);
        };

        img.src = background;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props2 = this.props,
            children = _props2.children,
            _props2$horizontal = _props2.horizontal,
            horizontal = _props2$horizontal === undefined ? false : _props2$horizontal;
        var _state = this.state,
            background = _state.background,
            blur = _state.blur,
            waypoint = _state.waypoint;
        var className = this.props.className ? this.props.className + ' react-lazy-blur' : 'react-lazy-blur';
        return _react2.default.createElement('span', null, _react2.default.createElement(_reactWaypoint2.default, {
          horizontal: horizontal,
          onEnter: function onEnter() {
            _this2.setState({
              waypoint: true
            });
          },
          scrollableAncestor: window
        }), _react2.default.createElement('div', {
          className: className,
          style: {
            position: 'relative'
          }
        }, _react2.default.createElement('div', {
          className: 'react-lazy-blur background',
          style: background
        }, children), !this.state.loaded ? _react2.default.createElement('div', {
          className: 'react-lazy-blur blur',
          style: (0, _assign2.default)({
            position: 'absolute',
            top: 0
          }, blur)
        }, children) : null), _react2.default.createElement(_reactWaypoint2.default, {
          horizontal: horizontal,
          onEnter: function onEnter() {
            _this2.setState({
              waypoint: true
            });
          },
          scrollableAncestor: window
        }));
      }
    }]);
    return ReactLazyBlur;
  }(_react2.default.Component);

  exports.default = ReactLazyBlur;
  /***/
},
/* 50 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = {
    "default": __webpack_require__(51),
    __esModule: true
  };
  /***/
},
/* 51 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(52);

  module.exports = __webpack_require__(0).Object.assign;
  /***/
},
/* 52 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.3.1 Object.assign(target, source)
  var $export = __webpack_require__(2);

  $export($export.S + $export.F, 'Object', {
    assign: __webpack_require__(54)
  });
  /***/
},
/* 53 */

/***/
function (module, exports) {
  module.exports = function (it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
  };
  /***/

},
/* 54 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // 19.1.2.1 Object.assign(target, source, ...)

  var getKeys = __webpack_require__(13),
      gOPS = __webpack_require__(23),
      pIE = __webpack_require__(16),
      toObject = __webpack_require__(24),
      IObject = __webpack_require__(39),
      $assign = Object.assign; // should work with symbols and should have deterministic property order (V8 bug)


  module.exports = !$assign || __webpack_require__(9)(function () {
    var A = {},
        B = {},
        S = Symbol(),
        K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function (k) {
      B[k] = k;
    });
    return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
  }) ? function assign(target, source) {
    // eslint-disable-line no-unused-vars
    var T = toObject(target),
        aLen = arguments.length,
        index = 1,
        getSymbols = gOPS.f,
        isEnum = pIE.f;

    while (aLen > index) {
      var S = IObject(arguments[index++]),
          keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S),
          length = keys.length,
          j = 0,
          key;

      while (length > j) {
        if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
      }
    }

    return T;
  } : $assign;
  /***/
},
/* 55 */

/***/
function (module, exports, __webpack_require__) {
  // false -> Array#indexOf
  // true  -> Array#includes
  var toIObject = __webpack_require__(6),
      toLength = __webpack_require__(56),
      toIndex = __webpack_require__(57);

  module.exports = function (IS_INCLUDES) {
    return function ($this, el, fromIndex) {
      var O = toIObject($this),
          length = toLength(O.length),
          index = toIndex(fromIndex, length),
          value; // Array#includes uses SameValueZero equality algorithm

      if (IS_INCLUDES && el != el) while (length > index) {
        value = O[index++];
        if (value != value) return true; // Array#toIndex ignores holes, Array#includes - not
      } else for (; length > index; index++) {
        if (IS_INCLUDES || index in O) {
          if (O[index] === el) return IS_INCLUDES || index || 0;
        }
      }
      return !IS_INCLUDES && -1;
    };
  };
  /***/

},
/* 56 */

/***/
function (module, exports, __webpack_require__) {
  // 7.1.15 ToLength
  var toInteger = __webpack_require__(19),
      min = Math.min;

  module.exports = function (it) {
    return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
  };
  /***/

},
/* 57 */

/***/
function (module, exports, __webpack_require__) {
  var toInteger = __webpack_require__(19),
      max = Math.max,
      min = Math.min;

  module.exports = function (index, length) {
    index = toInteger(index);
    return index < 0 ? max(index + length, 0) : min(index, length);
  };
  /***/

},
/* 58 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = {
    "default": __webpack_require__(59),
    __esModule: true
  };
  /***/
},
/* 59 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(60);

  module.exports = __webpack_require__(0).Object.getPrototypeOf;
  /***/
},
/* 60 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.2.9 Object.getPrototypeOf(O)
  var toObject = __webpack_require__(24),
      $getPrototypeOf = __webpack_require__(41);

  __webpack_require__(61)('getPrototypeOf', function () {
    return function getPrototypeOf(it) {
      return $getPrototypeOf(toObject(it));
    };
  });
  /***/

},
/* 61 */

/***/
function (module, exports, __webpack_require__) {
  // most Object methods by ES6 should accept primitives
  var $export = __webpack_require__(2),
      core = __webpack_require__(0),
      fails = __webpack_require__(9);

  module.exports = function (KEY, exec) {
    var fn = (core.Object || {})[KEY] || Object[KEY],
        exp = {};
    exp[KEY] = exec(fn);
    $export($export.S + $export.F * fails(function () {
      fn(1);
    }), 'Object', exp);
  };
  /***/

},
/* 62 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;

  exports.default = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };
  /***/

},
/* 63 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;

  var _defineProperty = __webpack_require__(64);

  var _defineProperty2 = _interopRequireDefault(_defineProperty);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, _defineProperty2.default)(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  /***/

},
/* 64 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = {
    "default": __webpack_require__(65),
    __esModule: true
  };
  /***/
},
/* 65 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(66);

  var $Object = __webpack_require__(0).Object;

  module.exports = function defineProperty(it, key, desc) {
    return $Object.defineProperty(it, key, desc);
  };
  /***/

},
/* 66 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(2); // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)


  $export($export.S + $export.F * !__webpack_require__(4), 'Object', {
    defineProperty: __webpack_require__(3).f
  });
  /***/
},
/* 67 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;

  var _typeof2 = __webpack_require__(42);

  var _typeof3 = _interopRequireDefault(_typeof2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = function (self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
  };
  /***/

},
/* 68 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = {
    "default": __webpack_require__(69),
    __esModule: true
  };
  /***/
},
/* 69 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(70);

  __webpack_require__(75);

  module.exports = __webpack_require__(29).f('iterator');
  /***/
},
/* 70 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var $at = __webpack_require__(71)(true); // 21.1.3.27 String.prototype[@@iterator]()


  __webpack_require__(43)(String, 'String', function (iterated) {
    this._t = String(iterated); // target

    this._i = 0; // next index
    // 21.1.5.2.1 %StringIteratorPrototype%.next()
  }, function () {
    var O = this._t,
        index = this._i,
        point;
    if (index >= O.length) return {
      value: undefined,
      done: true
    };
    point = $at(O, index);
    this._i += point.length;
    return {
      value: point,
      done: false
    };
  });
  /***/

},
/* 71 */

/***/
function (module, exports, __webpack_require__) {
  var toInteger = __webpack_require__(19),
      defined = __webpack_require__(18); // true  -> String#at
  // false -> String#codePointAt


  module.exports = function (TO_STRING) {
    return function (that, pos) {
      var s = String(defined(that)),
          i = toInteger(pos),
          l = s.length,
          a,
          b;
      if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
      a = s.charCodeAt(i);
      return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
  };
  /***/

},
/* 72 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var create = __webpack_require__(27),
      descriptor = __webpack_require__(14),
      setToStringTag = __webpack_require__(28),
      IteratorPrototype = {}; // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()


  __webpack_require__(8)(IteratorPrototype, __webpack_require__(10)('iterator'), function () {
    return this;
  });

  module.exports = function (Constructor, NAME, next) {
    Constructor.prototype = create(IteratorPrototype, {
      next: descriptor(1, next)
    });
    setToStringTag(Constructor, NAME + ' Iterator');
  };
  /***/

},
/* 73 */

/***/
function (module, exports, __webpack_require__) {
  var dP = __webpack_require__(3),
      anObject = __webpack_require__(11),
      getKeys = __webpack_require__(13);

  module.exports = __webpack_require__(4) ? Object.defineProperties : function defineProperties(O, Properties) {
    anObject(O);
    var keys = getKeys(Properties),
        length = keys.length,
        i = 0,
        P;

    while (length > i) {
      dP.f(O, P = keys[i++], Properties[P]);
    }

    return O;
  };
  /***/
},
/* 74 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__(1).document && document.documentElement;
  /***/
},
/* 75 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(76);

  var global = __webpack_require__(1),
      hide = __webpack_require__(8),
      Iterators = __webpack_require__(26),
      TO_STRING_TAG = __webpack_require__(10)('toStringTag');

  for (var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++) {
    var NAME = collections[i],
        Collection = global[NAME],
        proto = Collection && Collection.prototype;
    if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = Iterators.Array;
  }
  /***/

},
/* 76 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  var addToUnscopables = __webpack_require__(77),
      step = __webpack_require__(78),
      Iterators = __webpack_require__(26),
      toIObject = __webpack_require__(6); // 22.1.3.4 Array.prototype.entries()
  // 22.1.3.13 Array.prototype.keys()
  // 22.1.3.29 Array.prototype.values()
  // 22.1.3.30 Array.prototype[@@iterator]()


  module.exports = __webpack_require__(43)(Array, 'Array', function (iterated, kind) {
    this._t = toIObject(iterated); // target

    this._i = 0; // next index

    this._k = kind; // kind
    // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
  }, function () {
    var O = this._t,
        kind = this._k,
        index = this._i++;

    if (!O || index >= O.length) {
      this._t = undefined;
      return step(1);
    }

    if (kind == 'keys') return step(0, index);
    if (kind == 'values') return step(0, O[index]);
    return step(0, [index, O[index]]);
  }, 'values'); // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)

  Iterators.Arguments = Iterators.Array;
  addToUnscopables('keys');
  addToUnscopables('values');
  addToUnscopables('entries');
  /***/
},
/* 77 */

/***/
function (module, exports) {
  module.exports = function () {
    /* empty */
  };
  /***/

},
/* 78 */

/***/
function (module, exports) {
  module.exports = function (done, value) {
    return {
      value: value,
      done: !!done
    };
  };
  /***/

},
/* 79 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = {
    "default": __webpack_require__(80),
    __esModule: true
  };
  /***/
},
/* 80 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(81);

  __webpack_require__(87);

  __webpack_require__(88);

  __webpack_require__(89);

  module.exports = __webpack_require__(0).Symbol;
  /***/
},
/* 81 */

/***/
function (module, exports, __webpack_require__) {
  "use strict"; // ECMAScript 6 symbols shim

  var global = __webpack_require__(1),
      has = __webpack_require__(5),
      DESCRIPTORS = __webpack_require__(4),
      $export = __webpack_require__(2),
      redefine = __webpack_require__(44),
      META = __webpack_require__(82).KEY,
      $fails = __webpack_require__(9),
      shared = __webpack_require__(21),
      setToStringTag = __webpack_require__(28),
      uid = __webpack_require__(15),
      wks = __webpack_require__(10),
      wksExt = __webpack_require__(29),
      wksDefine = __webpack_require__(30),
      keyOf = __webpack_require__(83),
      enumKeys = __webpack_require__(84),
      isArray = __webpack_require__(85),
      anObject = __webpack_require__(11),
      toIObject = __webpack_require__(6),
      toPrimitive = __webpack_require__(17),
      createDesc = __webpack_require__(14),
      _create = __webpack_require__(27),
      gOPNExt = __webpack_require__(86),
      $GOPD = __webpack_require__(46),
      $DP = __webpack_require__(3),
      $keys = __webpack_require__(13),
      gOPD = $GOPD.f,
      dP = $DP.f,
      gOPN = gOPNExt.f,
      $Symbol = global.Symbol,
      $JSON = global.JSON,
      _stringify = $JSON && $JSON.stringify,
      PROTOTYPE = 'prototype',
      HIDDEN = wks('_hidden'),
      TO_PRIMITIVE = wks('toPrimitive'),
      isEnum = {}.propertyIsEnumerable,
      SymbolRegistry = shared('symbol-registry'),
      AllSymbols = shared('symbols'),
      OPSymbols = shared('op-symbols'),
      ObjectProto = Object[PROTOTYPE],
      USE_NATIVE = typeof $Symbol == 'function',
      QObject = global.QObject; // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173


  var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild; // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687

  var setSymbolDesc = DESCRIPTORS && $fails(function () {
    return _create(dP({}, 'a', {
      get: function get() {
        return dP(this, 'a', {
          value: 7
        }).a;
      }
    })).a != 7;
  }) ? function (it, key, D) {
    var protoDesc = gOPD(ObjectProto, key);
    if (protoDesc) delete ObjectProto[key];
    dP(it, key, D);
    if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
  } : dP;

  var wrap = function wrap(tag) {
    var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);

    sym._k = tag;
    return sym;
  };

  var isSymbol = USE_NATIVE && _typeof4($Symbol.iterator) == 'symbol' ? function (it) {
    return _typeof4(it) == 'symbol';
  } : function (it) {
    return it instanceof $Symbol;
  };

  var $defineProperty = function defineProperty(it, key, D) {
    if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
    anObject(it);
    key = toPrimitive(key, true);
    anObject(D);

    if (has(AllSymbols, key)) {
      if (!D.enumerable) {
        if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
        it[HIDDEN][key] = true;
      } else {
        if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
        D = _create(D, {
          enumerable: createDesc(0, false)
        });
      }

      return setSymbolDesc(it, key, D);
    }

    return dP(it, key, D);
  };

  var $defineProperties = function defineProperties(it, P) {
    anObject(it);
    var keys = enumKeys(P = toIObject(P)),
        i = 0,
        l = keys.length,
        key;

    while (l > i) {
      $defineProperty(it, key = keys[i++], P[key]);
    }

    return it;
  };

  var $create = function create(it, P) {
    return P === undefined ? _create(it) : $defineProperties(_create(it), P);
  };

  var $propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = isEnum.call(this, key = toPrimitive(key, true));
    if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
    return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
  };

  var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = toIObject(it);
    key = toPrimitive(key, true);
    if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
    var D = gOPD(it, key);
    if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
    return D;
  };

  var $getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = gOPN(toIObject(it)),
        result = [],
        i = 0,
        key;

    while (names.length > i) {
      if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
    }

    return result;
  };

  var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === ObjectProto,
        names = gOPN(IS_OP ? OPSymbols : toIObject(it)),
        result = [],
        i = 0,
        key;

    while (names.length > i) {
      if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
    }

    return result;
  }; // 19.4.1.1 Symbol([description])


  if (!USE_NATIVE) {
    $Symbol = function _Symbol2() {
      if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
      var tag = uid(arguments.length > 0 ? arguments[0] : undefined);

      var $set = function $set(value) {
        if (this === ObjectProto) $set.call(OPSymbols, value);
        if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
        setSymbolDesc(this, tag, createDesc(1, value));
      };

      if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, {
        configurable: true,
        set: $set
      });
      return wrap(tag);
    };

    redefine($Symbol[PROTOTYPE], 'toString', function toString() {
      return this._k;
    });
    $GOPD.f = $getOwnPropertyDescriptor;
    $DP.f = $defineProperty;
    __webpack_require__(45).f = gOPNExt.f = $getOwnPropertyNames;
    __webpack_require__(16).f = $propertyIsEnumerable;
    __webpack_require__(23).f = $getOwnPropertySymbols;

    if (DESCRIPTORS && !__webpack_require__(25)) {
      redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
    }

    wksExt.f = function (name) {
      return wrap(wks(name));
    };
  }

  $export($export.G + $export.W + $export.F * !USE_NATIVE, {
    Symbol: $Symbol
  });

  for (var symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), i = 0; symbols.length > i;) {
    wks(symbols[i++]);
  }

  for (var symbols = $keys(wks.store), i = 0; symbols.length > i;) {
    wksDefine(symbols[i++]);
  }

  $export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function _for(key) {
      return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(key) {
      if (isSymbol(key)) return keyOf(SymbolRegistry, key);
      throw TypeError(key + ' is not a symbol!');
    },
    useSetter: function useSetter() {
      setter = true;
    },
    useSimple: function useSimple() {
      setter = false;
    }
  });
  $export($export.S + $export.F * !USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $getOwnPropertySymbols
  }); // 24.3.2 JSON.stringify(value [, replacer [, space]])

  $JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
    var S = $Symbol(); // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols

    return _stringify([S]) != '[null]' || _stringify({
      a: S
    }) != '{}' || _stringify(Object(S)) != '{}';
  })), 'JSON', {
    stringify: function stringify(it) {
      if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined

      var args = [it],
          i = 1,
          replacer,
          $replacer;

      while (arguments.length > i) {
        args.push(arguments[i++]);
      }

      replacer = args[1];
      if (typeof replacer == 'function') $replacer = replacer;
      if ($replacer || !isArray(replacer)) replacer = function replacer(key, value) {
        if ($replacer) value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return _stringify.apply($JSON, args);
    }
  }); // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)

  $Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(8)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf); // 19.4.3.5 Symbol.prototype[@@toStringTag]

  setToStringTag($Symbol, 'Symbol'); // 20.2.1.9 Math[@@toStringTag]

  setToStringTag(Math, 'Math', true); // 24.3.3 JSON[@@toStringTag]

  setToStringTag(global.JSON, 'JSON', true);
  /***/
},
/* 82 */

/***/
function (module, exports, __webpack_require__) {
  var META = __webpack_require__(15)('meta'),
      isObject = __webpack_require__(12),
      has = __webpack_require__(5),
      setDesc = __webpack_require__(3).f,
      id = 0;

  var isExtensible = Object.isExtensible || function () {
    return true;
  };

  var FREEZE = !__webpack_require__(9)(function () {
    return isExtensible(Object.preventExtensions({}));
  });

  var setMeta = function setMeta(it) {
    setDesc(it, META, {
      value: {
        i: 'O' + ++id,
        // object ID
        w: {} // weak collections IDs

      }
    });
  };

  var fastKey = function fastKey(it, create) {
    // return primitive with prefix
    if (!isObject(it)) return _typeof4(it) == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;

    if (!has(it, META)) {
      // can't set metadata to uncaught frozen object
      if (!isExtensible(it)) return 'F'; // not necessary to add metadata

      if (!create) return 'E'; // add missing metadata

      setMeta(it); // return object ID
    }

    return it[META].i;
  };

  var getWeak = function getWeak(it, create) {
    if (!has(it, META)) {
      // can't set metadata to uncaught frozen object
      if (!isExtensible(it)) return true; // not necessary to add metadata

      if (!create) return false; // add missing metadata

      setMeta(it); // return hash weak collections IDs
    }

    return it[META].w;
  }; // add metadata on freeze-family methods calling


  var onFreeze = function onFreeze(it) {
    if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
    return it;
  };

  var meta = module.exports = {
    KEY: META,
    NEED: false,
    fastKey: fastKey,
    getWeak: getWeak,
    onFreeze: onFreeze
  };
  /***/
},
/* 83 */

/***/
function (module, exports, __webpack_require__) {
  var getKeys = __webpack_require__(13),
      toIObject = __webpack_require__(6);

  module.exports = function (object, el) {
    var O = toIObject(object),
        keys = getKeys(O),
        length = keys.length,
        index = 0,
        key;

    while (length > index) {
      if (O[key = keys[index++]] === el) return key;
    }
  };
  /***/

},
/* 84 */

/***/
function (module, exports, __webpack_require__) {
  // all enumerable object keys, includes symbols
  var getKeys = __webpack_require__(13),
      gOPS = __webpack_require__(23),
      pIE = __webpack_require__(16);

  module.exports = function (it) {
    var result = getKeys(it),
        getSymbols = gOPS.f;

    if (getSymbols) {
      var symbols = getSymbols(it),
          isEnum = pIE.f,
          i = 0,
          key;

      while (symbols.length > i) {
        if (isEnum.call(it, key = symbols[i++])) result.push(key);
      }
    }

    return result;
  };
  /***/

},
/* 85 */

/***/
function (module, exports, __webpack_require__) {
  // 7.2.2 IsArray(argument)
  var cof = __webpack_require__(40);

  module.exports = Array.isArray || function isArray(arg) {
    return cof(arg) == 'Array';
  };
  /***/

},
/* 86 */

/***/
function (module, exports, __webpack_require__) {
  // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
  var toIObject = __webpack_require__(6),
      gOPN = __webpack_require__(45).f,
      toString = {}.toString;

  var windowNames = (typeof window === "undefined" ? "undefined" : _typeof4(window)) == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

  var getWindowNames = function getWindowNames(it) {
    try {
      return gOPN(it);
    } catch (e) {
      return windowNames.slice();
    }
  };

  module.exports.f = function getOwnPropertyNames(it) {
    return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
  };
  /***/

},
/* 87 */

/***/
function (module, exports) {
  /***/
},
/* 88 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(30)('asyncIterator');
  /***/

},
/* 89 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(30)('observable');
  /***/

},
/* 90 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  exports.__esModule = true;

  var _setPrototypeOf = __webpack_require__(91);

  var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

  var _create = __webpack_require__(95);

  var _create2 = _interopRequireDefault(_create);

  var _typeof2 = __webpack_require__(42);

  var _typeof3 = _interopRequireDefault(_typeof2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = function (subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
    }

    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
  };
  /***/

},
/* 91 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = {
    "default": __webpack_require__(92),
    __esModule: true
  };
  /***/
},
/* 92 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(93);

  module.exports = __webpack_require__(0).Object.setPrototypeOf;
  /***/
},
/* 93 */

/***/
function (module, exports, __webpack_require__) {
  // 19.1.3.19 Object.setPrototypeOf(O, proto)
  var $export = __webpack_require__(2);

  $export($export.S, 'Object', {
    setPrototypeOf: __webpack_require__(94).set
  });
  /***/
},
/* 94 */

/***/
function (module, exports, __webpack_require__) {
  // Works with __proto__ only. Old v8 can't work with null proto objects.

  /* eslint-disable no-proto */
  var isObject = __webpack_require__(12),
      anObject = __webpack_require__(11);

  var check = function check(O, proto) {
    anObject(O);
    if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
  };

  module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(35)(Function.call, __webpack_require__(46).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) {
        buggy = true;
      }

      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
    check: check
  };
  /***/
},
/* 95 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = {
    "default": __webpack_require__(96),
    __esModule: true
  };
  /***/
},
/* 96 */

/***/
function (module, exports, __webpack_require__) {
  __webpack_require__(97);

  var $Object = __webpack_require__(0).Object;

  module.exports = function create(P, D) {
    return $Object.create(P, D);
  };
  /***/

},
/* 97 */

/***/
function (module, exports, __webpack_require__) {
  var $export = __webpack_require__(2); // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])


  $export($export.S, 'Object', {
    create: __webpack_require__(27)
  });
  /***/
},
/* 98 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();

    var _consolidatedEvents = __webpack_require__(99);

    var _propTypes = __webpack_require__(105);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    var _react = __webpack_require__(31);

    var _react2 = _interopRequireDefault(_react);

    var _computeOffsetPixels = __webpack_require__(109);

    var _computeOffsetPixels2 = _interopRequireDefault(_computeOffsetPixels);

    var _constants = __webpack_require__(48);

    var _constants2 = _interopRequireDefault(_constants);

    var _debugLog = __webpack_require__(112);

    var _debugLog2 = _interopRequireDefault(_debugLog);

    var _ensureChildrenIsSingleDOMElement = __webpack_require__(113);

    var _ensureChildrenIsSingleDOMElement2 = _interopRequireDefault(_ensureChildrenIsSingleDOMElement);

    var _getCurrentPosition = __webpack_require__(115);

    var _getCurrentPosition2 = _interopRequireDefault(_getCurrentPosition);

    var _onNextTick = __webpack_require__(116);

    var _onNextTick2 = _interopRequireDefault(_onNextTick);

    var _resolveScrollableAncestorProp = __webpack_require__(117);

    var _resolveScrollableAncestorProp2 = _interopRequireDefault(_resolveScrollableAncestorProp);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return call && (_typeof4(call) === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + _typeof4(superClass));
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var defaultProps = {
      topOffset: '0px',
      bottomOffset: '0px',
      horizontal: false,
      onEnter: function onEnter() {},
      onLeave: function onLeave() {},
      onPositionChange: function onPositionChange() {},
      fireOnRapidScroll: true
    };
    /**
     * Calls a function when you scroll to the element.
     */

    var Waypoint = function (_React$Component) {
      _inherits(Waypoint, _React$Component);

      function Waypoint(props) {
        _classCallCheck(this, Waypoint);

        var _this = _possibleConstructorReturn(this, (Waypoint.__proto__ || Object.getPrototypeOf(Waypoint)).call(this, props));

        _this.refElement = function (e) {
          return _this._ref = e;
        };

        return _this;
      }

      _createClass(Waypoint, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          (0, _ensureChildrenIsSingleDOMElement2.default)(this.props.children);

          if (this.props.scrollableParent) {
            // eslint-disable-line react/prop-types
            throw new Error('The `scrollableParent` prop has changed name to `scrollableAncestor`.');
          }
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _this2 = this;

          if (!Waypoint.getWindow()) {
            return;
          } // this._ref may occasionally not be set at this time. To help ensure that
          // this works smoothly, we want to delay the initial execution until the
          // next tick.


          this.cancelInitialTimeout = (0, _onNextTick2.default)(function () {
            _this2._handleScroll = _this2._handleScroll.bind(_this2);
            _this2.scrollableAncestor = _this2._findScrollableAncestor();

            if (process.env.NODE_ENV !== 'production' && _this2.props.debug) {
              (0, _debugLog2.default)('scrollableAncestor', _this2.scrollableAncestor);
            }

            _this2.scrollEventListenerUnsubscribe = (0, _consolidatedEvents.addEventListener)(_this2.scrollableAncestor, 'scroll', _this2._handleScroll, {
              passive: true
            });
            _this2.resizeEventListenerUnsubscribe = (0, _consolidatedEvents.addEventListener)(window, 'resize', _this2._handleScroll, {
              passive: true
            });

            _this2._handleScroll(null);
          });
        }
      }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
          (0, _ensureChildrenIsSingleDOMElement2.default)(nextProps.children);
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
          if (!Waypoint.getWindow()) {
            return;
          }

          if (!this.scrollableAncestor) {
            // The Waypoint has not yet initialized.
            return;
          } // The element may have moved.


          this._handleScroll(null);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (!Waypoint.getWindow()) {
            return;
          }

          if (this.scrollEventListenerUnsubscribe) {
            this.scrollEventListenerUnsubscribe();
          }

          if (this.resizeEventListenerUnsubscribe) {
            this.resizeEventListenerUnsubscribe();
          }

          if (this.cancelInitialTimeout) {
            this.cancelInitialTimeout();
          }
        }
        /**
         * Traverses up the DOM to find an ancestor container which has an overflow
         * style that allows for scrolling.
         *
         * @return {Object} the closest ancestor element with an overflow style that
         *   allows for scrolling. If none is found, the `window` object is returned
         *   as a fallback.
         */

      }, {
        key: '_findScrollableAncestor',
        value: function _findScrollableAncestor() {
          var _props = this.props,
              horizontal = _props.horizontal,
              scrollableAncestor = _props.scrollableAncestor;

          if (scrollableAncestor) {
            return (0, _resolveScrollableAncestorProp2.default)(scrollableAncestor);
          }

          var node = this._ref;

          while (node.parentNode) {
            node = node.parentNode;

            if (node === document.body) {
              // We've reached all the way to the root node.
              return window;
            }

            var style = window.getComputedStyle(node);
            var overflowDirec = horizontal ? style.getPropertyValue('overflow-x') : style.getPropertyValue('overflow-y');
            var overflow = overflowDirec || style.getPropertyValue('overflow');

            if (overflow === 'auto' || overflow === 'scroll') {
              return node;
            }
          } // A scrollable ancestor element was not found, which means that we need to
          // do stuff on window.


          return window;
        }
        /**
         * @param {Object} event the native scroll event coming from the scrollable
         *   ancestor, or resize event coming from the window. Will be undefined if
         *   called by a React lifecyle method
         */

      }, {
        key: '_handleScroll',
        value: function _handleScroll(event) {
          if (!this._ref) {
            // There's a chance we end up here after the component has been unmounted.
            return;
          }

          var bounds = this._getBounds();

          var currentPosition = (0, _getCurrentPosition2.default)(bounds);
          var previousPosition = this._previousPosition;

          if (process.env.NODE_ENV !== 'production' && this.props.debug) {
            (0, _debugLog2.default)('currentPosition', currentPosition);
            (0, _debugLog2.default)('previousPosition', previousPosition);
          } // Save previous position as early as possible to prevent cycles


          this._previousPosition = currentPosition;

          if (previousPosition === currentPosition) {
            // No change since last trigger
            return;
          }

          var callbackArg = {
            currentPosition: currentPosition,
            previousPosition: previousPosition,
            event: event,
            waypointTop: bounds.waypointTop,
            waypointBottom: bounds.waypointBottom,
            viewportTop: bounds.viewportTop,
            viewportBottom: bounds.viewportBottom
          };
          this.props.onPositionChange.call(this, callbackArg);

          if (currentPosition === _constants2.default.inside) {
            this.props.onEnter.call(this, callbackArg);
          } else if (previousPosition === _constants2.default.inside) {
            this.props.onLeave.call(this, callbackArg);
          }

          var isRapidScrollDown = previousPosition === _constants2.default.below && currentPosition === _constants2.default.above;
          var isRapidScrollUp = previousPosition === _constants2.default.above && currentPosition === _constants2.default.below;

          if (this.props.fireOnRapidScroll && (isRapidScrollDown || isRapidScrollUp)) {
            // If the scroll event isn't fired often enough to occur while the
            // waypoint was visible, we trigger both callbacks anyway.
            this.props.onEnter.call(this, {
              currentPosition: _constants2.default.inside,
              previousPosition: previousPosition,
              event: event,
              waypointTop: bounds.waypointTop,
              waypointBottom: bounds.waypointBottom,
              viewportTop: bounds.viewportTop,
              viewportBottom: bounds.viewportBottom
            });
            this.props.onLeave.call(this, {
              currentPosition: currentPosition,
              previousPosition: _constants2.default.inside,
              event: event,
              waypointTop: bounds.waypointTop,
              waypointBottom: bounds.waypointBottom,
              viewportTop: bounds.viewportTop,
              viewportBottom: bounds.viewportBottom
            });
          }
        }
      }, {
        key: '_getBounds',
        value: function _getBounds() {
          var horizontal = this.props.horizontal;

          var _ref$getBoundingClien = this._ref.getBoundingClientRect(),
              left = _ref$getBoundingClien.left,
              top = _ref$getBoundingClien.top,
              right = _ref$getBoundingClien.right,
              bottom = _ref$getBoundingClien.bottom;

          var waypointTop = horizontal ? left : top;
          var waypointBottom = horizontal ? right : bottom;
          var contextHeight = void 0;
          var contextScrollTop = void 0;

          if (this.scrollableAncestor === window) {
            contextHeight = horizontal ? window.innerWidth : window.innerHeight;
            contextScrollTop = 0;
          } else {
            contextHeight = horizontal ? this.scrollableAncestor.offsetWidth : this.scrollableAncestor.offsetHeight;
            contextScrollTop = horizontal ? this.scrollableAncestor.getBoundingClientRect().left : this.scrollableAncestor.getBoundingClientRect().top;
          }

          if (process.env.NODE_ENV !== 'production' && this.props.debug) {
            (0, _debugLog2.default)('waypoint top', waypointTop);
            (0, _debugLog2.default)('waypoint bottom', waypointBottom);
            (0, _debugLog2.default)('scrollableAncestor height', contextHeight);
            (0, _debugLog2.default)('scrollableAncestor scrollTop', contextScrollTop);
          }

          var _props2 = this.props,
              bottomOffset = _props2.bottomOffset,
              topOffset = _props2.topOffset;
          var topOffsetPx = (0, _computeOffsetPixels2.default)(topOffset, contextHeight);
          var bottomOffsetPx = (0, _computeOffsetPixels2.default)(bottomOffset, contextHeight);
          var contextBottom = contextScrollTop + contextHeight;
          return {
            waypointTop: waypointTop,
            waypointBottom: waypointBottom,
            viewportTop: contextScrollTop + topOffsetPx,
            viewportBottom: contextBottom - bottomOffsetPx
          };
        }
        /**
         * @return {Object}
         */

      }, {
        key: 'render',
        value: function render() {
          var _this3 = this;

          var children = this.props.children;

          if (!children) {
            // We need an element that we can locate in the DOM to determine where it is
            // rendered relative to the top of its context.
            return _react2.default.createElement('span', {
              ref: this.refElement,
              style: {
                fontSize: 0
              }
            });
          }

          var ref = function ref(node) {
            _this3.refElement(node);

            if (children.ref) {
              children.ref(node);
            }
          };

          return _react2.default.cloneElement(children, {
            ref: ref
          });
        }
      }]);

      return Waypoint;
    }(_react2.default.Component);

    exports.default = Waypoint;
    Waypoint.propTypes = {
      children: _propTypes2.default.element,
      debug: _propTypes2.default.bool,
      onEnter: _propTypes2.default.func,
      onLeave: _propTypes2.default.func,
      onPositionChange: _propTypes2.default.func,
      fireOnRapidScroll: _propTypes2.default.bool,
      scrollableAncestor: _propTypes2.default.any,
      horizontal: _propTypes2.default.bool,
      // `topOffset` can either be a number, in which case its a distance from the
      // top of the container in pixels, or a string value. Valid string values are
      // of the form "20px", which is parsed as pixels, or "20%", which is parsed
      // as a percentage of the height of the containing element.
      // For instance, if you pass "-20%", and the containing element is 100px tall,
      // then the waypoint will be triggered when it has been scrolled 20px beyond
      // the top of the containing element.
      topOffset: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
      // `bottomOffset` is like `topOffset`, but for the bottom of the container.
      bottomOffset: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
    };
    Waypoint.above = _constants2.default.above;
    Waypoint.below = _constants2.default.below;
    Waypoint.inside = _constants2.default.inside;
    Waypoint.invisible = _constants2.default.invisible;

    Waypoint.getWindow = function () {
      if (typeof window !== 'undefined') {
        return window;
      }
    };

    Waypoint.defaultProps = defaultProps;
    Waypoint.displayName = 'Waypoint';
    module.exports = exports['default'];
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(7));
  /***/
},
/* 99 */

/***/
function (module, exports, __webpack_require__) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.EVENT_HANDLERS_KEY = undefined;
  exports.addEventListener = addEventListener;
  exports.removeEventListener = removeEventListener;

  var _normalizeEventOptions = __webpack_require__(100);

  var _normalizeEventOptions2 = _interopRequireDefault(_normalizeEventOptions);

  var _TargetEventHandlers = __webpack_require__(103);

  var _TargetEventHandlers2 = _interopRequireDefault(_TargetEventHandlers);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  } // Export to make testing possible.


  var EVENT_HANDLERS_KEY = exports.EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';

  function addEventListener(target, eventName, listener, options) {
    if (!target[EVENT_HANDLERS_KEY]) {
      // eslint-disable-next-line no-param-reassign
      target[EVENT_HANDLERS_KEY] = new _TargetEventHandlers2['default'](target);
    }

    var normalizedEventOptions = (0, _normalizeEventOptions2['default'])(options);
    return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
  } // Deprecated


  function removeEventListener(unsubscribeFn) {
    unsubscribeFn();
  }
  /***/

},
/* 100 */

/***/
function (module, exports, __webpack_require__) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports['default'] = normalizeEventOptions;

  var _canUsePassiveEventListeners = __webpack_require__(101);

  var _canUsePassiveEventListeners2 = _interopRequireDefault(_canUsePassiveEventListeners);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function normalizeEventOptions(eventOptions) {
    if (!eventOptions) {
      return undefined;
    }

    if (!(0, _canUsePassiveEventListeners2['default'])()) {
      // If the browser does not support the passive option, then it is expecting
      // a boolean for the options argument to specify whether it should use
      // capture or not. In more modern browsers, this is passed via the `capture`
      // option, so let's just hoist that value up.
      return !!eventOptions.capture;
    }

    return eventOptions;
  }
  /***/

},
/* 101 */

/***/
function (module, exports, __webpack_require__) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports['default'] = canUsePassiveEventListeners;

  var _canUseDOM = __webpack_require__(102);

  var _canUseDOM2 = _interopRequireDefault(_canUseDOM);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  } // Adapted from Modernizr
  // https://github.com/Modernizr/Modernizr/blob/5eea7e2a/feature-detects/dom/passiveeventlisteners.js#L26-L35


  function testPassiveEventListeners() {
    if (!_canUseDOM2['default']) {
      return false;
    }

    if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
      return false;
    }

    var supportsPassiveOption = false;

    try {
      var opts = Object.defineProperty({}, 'passive', {
        get: function () {
          function get() {
            supportsPassiveOption = true;
          }

          return get;
        }()
      });
      window.addEventListener('test', null, opts);
    } catch (e) {// do nothing
    }

    return supportsPassiveOption;
  }

  var memoized = void 0;

  function canUsePassiveEventListeners() {
    if (memoized === undefined) {
      memoized = testPassiveEventListeners();
    }

    return memoized;
  }
  /***/

},
/* 102 */

/***/
function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
  exports['default'] = CAN_USE_DOM;
  /***/
},
/* 103 */

/***/
function (module, exports, __webpack_require__) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _eventOptionsKey = __webpack_require__(104);

  var _eventOptionsKey2 = _interopRequireDefault(_eventOptionsKey);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      'default': obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var TargetEventHandlers = function () {
    function TargetEventHandlers(target) {
      _classCallCheck(this, TargetEventHandlers);

      this.target = target;
      this.events = {};
    }

    _createClass(TargetEventHandlers, [{
      key: 'getEventHandlers',
      value: function () {
        function getEventHandlers(eventName, options) {
          var key = String(eventName) + ' ' + String((0, _eventOptionsKey2['default'])(options));

          if (!this.events[key]) {
            this.events[key] = {
              handlers: [],
              handleEvent: undefined
            };
          }

          return this.events[key];
        }

        return getEventHandlers;
      }()
    }, {
      key: 'handleEvent',
      value: function () {
        function handleEvent(eventName, options, event) {
          var _getEventHandlers = this.getEventHandlers(eventName, options),
              handlers = _getEventHandlers.handlers;

          handlers.forEach(function (handler) {
            if (handler) {
              // We need to check for presence here because a handler function may
              // cause later handlers to get removed. This can happen if you for
              // instance have a waypoint that unmounts another waypoint as part of an
              // onEnter/onLeave handler.
              handler(event);
            }
          });
        }

        return handleEvent;
      }()
    }, {
      key: 'add',
      value: function () {
        function add(eventName, listener, options) {
          var _this = this; // options has already been normalized at this point.


          var eventHandlers = this.getEventHandlers(eventName, options);

          if (eventHandlers.handlers.length === 0) {
            eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);
            this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
          }

          eventHandlers.handlers.push(listener);
          var isSubscribed = true;

          var unsubscribe = function () {
            function unsubscribe() {
              if (!isSubscribed) {
                return;
              }

              isSubscribed = false;
              var index = eventHandlers.handlers.indexOf(listener);
              eventHandlers.handlers.splice(index, 1);

              if (eventHandlers.handlers.length === 0) {
                // All event handlers have been removed, so we want to remove the event
                // listener from the target node.
                if (_this.target) {
                  // There can be a race condition where the target may no longer exist
                  // when this function is called, e.g. when a React component is
                  // unmounting. Guarding against this prevents the following error:
                  //
                  //   Cannot read property 'removeEventListener' of undefined
                  _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
                }

                eventHandlers.handleEvent = undefined;
              }
            }

            return unsubscribe;
          }();

          return unsubscribe;
        }

        return add;
      }()
    }]);

    return TargetEventHandlers;
  }();

  exports['default'] = TargetEventHandlers;
  /***/
},
/* 104 */

/***/
function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = eventOptionsKey;
  /* eslint-disable no-bitwise */

  /**
   * Generate a unique key for any set of event options
   */

  function eventOptionsKey(normalizedEventOptions) {
    if (!normalizedEventOptions) {
      return 0;
    } // If the browser does not support passive event listeners, the normalized
    // event options will be a boolean.


    if (normalizedEventOptions === true) {
      return 100;
    } // At this point, the browser supports passive event listeners, so we expect
    // the event options to be an object with possible properties of capture,
    // passive, and once.
    //
    // We want to consistently return the same value, regardless of the order of
    // these properties, so let's use binary maths to assign each property to a
    // bit, and then add those together (with an offset to account for the
    // booleans at the beginning of this function).


    var capture = normalizedEventOptions.capture << 0;
    var passive = normalizedEventOptions.passive << 1;
    var once = normalizedEventOptions.once << 2;
    return capture + passive + once;
  }
  /***/

},
/* 105 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (process) {
    /**
    * Copyright 2013-present, Facebook, Inc.
    * All rights reserved.
    *
    * This source code is licensed under the BSD-style license found in the
    * LICENSE file in the root directory of this source tree. An additional grant
    * of patent rights can be found in the PATENTS file in the same directory.
    */
    if (process.env.NODE_ENV !== 'production') {
      var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

      var isValidElement = function isValidElement(object) {
        return _typeof4(object) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }; // By explicitly using `prop-types` you are opting into new development behavior.
      // http://fb.me/prop-types-in-prod


      var throwOnDirectAccess = true;
      module.exports = __webpack_require__(106)(isValidElement, throwOnDirectAccess);
    } else {
      // By explicitly using `prop-types` you are opting into new production behavior.
      // http://fb.me/prop-types-in-prod
      module.exports = __webpack_require__(108)();
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(7));
  /***/
},
/* 106 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /**
    * Copyright 2013-present, Facebook, Inc.
    * All rights reserved.
    *
    * This source code is licensed under the BSD-style license found in the
    * LICENSE file in the root directory of this source tree. An additional grant
    * of patent rights can be found in the PATENTS file in the same directory.
    */
    var emptyFunction = __webpack_require__(32);

    var invariant = __webpack_require__(33);

    var warning = __webpack_require__(47);

    var ReactPropTypesSecret = __webpack_require__(34);

    var checkPropTypes = __webpack_require__(107);

    module.exports = function (isValidElement, throwOnDirectAccess) {
      /* global Symbol */
      var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

      /**
       * Returns the iterator method function contained on the iterable object.
       *
       * Be sure to invoke the function with the iterable as context:
       *
       *     var iteratorFn = getIteratorFn(myIterable);
       *     if (iteratorFn) {
       *       var iterator = iteratorFn.call(myIterable);
       *       ...
       *     }
       *
       * @param {?object} maybeIterable
       * @return {?function}
       */

      function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

        if (typeof iteratorFn === 'function') {
          return iteratorFn;
        }
      }
      /**
       * Collection of methods that allow declaration and validation of props that are
       * supplied to React components. Example usage:
       *
       *   var Props = require('ReactPropTypes');
       *   var MyArticle = React.createClass({
       *     propTypes: {
       *       // An optional string prop named "description".
       *       description: Props.string,
       *
       *       // A required enum prop named "category".
       *       category: Props.oneOf(['News','Photos']).isRequired,
       *
       *       // A prop named "dialog" that requires an instance of Dialog.
       *       dialog: Props.instanceOf(Dialog).isRequired
       *     },
       *     render: function() { ... }
       *   });
       *
       * A more formal specification of how these methods are used:
       *
       *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
       *   decl := ReactPropTypes.{type}(.isRequired)?
       *
       * Each and every declaration produces a function with the same signature. This
       * allows the creation of custom validation functions. For example:
       *
       *  var MyLink = React.createClass({
       *    propTypes: {
       *      // An optional string or URI prop named "href".
       *      href: function(props, propName, componentName) {
       *        var propValue = props[propName];
       *        if (propValue != null && typeof propValue !== 'string' &&
       *            !(propValue instanceof URI)) {
       *          return new Error(
       *            'Expected a string or an URI for ' + propName + ' in ' +
       *            componentName
       *          );
       *        }
       *      }
       *    },
       *    render: function() {...}
       *  });
       *
       * @internal
       */


      var ANONYMOUS = '<<anonymous>>'; // Important!
      // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

      var ReactPropTypes = {
        array: createPrimitiveTypeChecker('array'),
        bool: createPrimitiveTypeChecker('boolean'),
        func: createPrimitiveTypeChecker('function'),
        number: createPrimitiveTypeChecker('number'),
        object: createPrimitiveTypeChecker('object'),
        string: createPrimitiveTypeChecker('string'),
        symbol: createPrimitiveTypeChecker('symbol'),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker
      };
      /**
       * inlined Object.is polyfill to avoid requiring consumers ship their own
       * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
       */

      /*eslint-disable no-self-compare*/

      function is(x, y) {
        // SameValue algorithm
        if (x === y) {
          // Steps 1-5, 7-10
          // Steps 6.b-6.e: +0 != -0
          return x !== 0 || 1 / x === 1 / y;
        } else {
          // Step 6.a: NaN == NaN
          return x !== x && y !== y;
        }
      }
      /*eslint-enable no-self-compare*/

      /**
       * We use an Error-like object for backward compatibility as people may call
       * PropTypes directly and inspect their output. However, we don't use real
       * Errors anymore. We don't inspect their stack anyway, and creating them
       * is prohibitively expensive if they are created too often, such as what
       * happens in oneOfType() for any type before the one that matched.
       */


      function PropTypeError(message) {
        this.message = message;
        this.stack = '';
      } // Make `instanceof Error` still work for returned errors.


      PropTypeError.prototype = Error.prototype;

      function createChainableTypeChecker(validate) {
        if (process.env.NODE_ENV !== 'production') {
          var manualPropTypeCallCache = {};
          var manualPropTypeWarningCount = 0;
        }

        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
          componentName = componentName || ANONYMOUS;
          propFullName = propFullName || propName;

          if (secret !== ReactPropTypesSecret) {
            if (throwOnDirectAccess) {
              // New behavior only for users of `prop-types` package
              invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
            } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
              // Old behavior for people using React.PropTypes
              var cacheKey = componentName + ':' + propName;

              if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3) {
                warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.', propFullName, componentName);
                manualPropTypeCallCache[cacheKey] = true;
                manualPropTypeWarningCount++;
              }
            }
          }

          if (props[propName] == null) {
            if (isRequired) {
              if (props[propName] === null) {
                return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
              }

              return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
            }

            return null;
          } else {
            return validate(props, propName, componentName, location, propFullName);
          }
        }

        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
      }

      function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
          var propValue = props[propName];
          var propType = getPropType(propValue);

          if (propType !== expectedType) {
            // `propValue` being instance of, say, date/regexp, pass the 'object'
            // check, but we can offer a more precise error message here rather than
            // 'of type `object`'.
            var preciseType = getPreciseType(propValue);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunction.thatReturnsNull);
      }

      function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== 'function') {
            return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
          }

          var propValue = props[propName];

          if (!Array.isArray(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
          }

          for (var i = 0; i < propValue.length; i++) {
            var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);

            if (error instanceof Error) {
              return error;
            }
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];

          if (!isValidElement(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
          if (!(props[propName] instanceof expectedClass)) {
            var expectedClassName = expectedClass.name || ANONYMOUS;
            var actualClassName = getClassName(props[propName]);
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
          return emptyFunction.thatReturnsNull;
        }

        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];

          for (var i = 0; i < expectedValues.length; i++) {
            if (is(propValue, expectedValues[i])) {
              return null;
            }
          }

          var valuesString = JSON.stringify(expectedValues);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
        }

        return createChainableTypeChecker(validate);
      }

      function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== 'function') {
            return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
          }

          var propValue = props[propName];
          var propType = getPropType(propValue);

          if (propType !== 'object') {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
          }

          for (var key in propValue) {
            if (propValue.hasOwnProperty(key)) {
              var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);

              if (error instanceof Error) {
                return error;
              }
            }
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
          return emptyFunction.thatReturnsNull;
        }

        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];

          if (typeof checker !== 'function') {
            warning(false, 'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' + 'received %s at index %s.', getPostfixForTypeWarning(checker), i);
            return emptyFunction.thatReturnsNull;
          }
        }

        function validate(props, propName, componentName, location, propFullName) {
          for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
            var checker = arrayOfTypeCheckers[i];

            if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
              return null;
            }
          }

          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
        }

        return createChainableTypeChecker(validate);
      }

      function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          if (!isNode(props[propName])) {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);

          if (propType !== 'object') {
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
          }

          for (var key in shapeTypes) {
            var checker = shapeTypes[key];

            if (!checker) {
              continue;
            }

            var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);

            if (error) {
              return error;
            }
          }

          return null;
        }

        return createChainableTypeChecker(validate);
      }

      function isNode(propValue) {
        switch (_typeof4(propValue)) {
          case 'number':
          case 'string':
          case 'undefined':
            return true;

          case 'boolean':
            return !propValue;

          case 'object':
            if (Array.isArray(propValue)) {
              return propValue.every(isNode);
            }

            if (propValue === null || isValidElement(propValue)) {
              return true;
            }

            var iteratorFn = getIteratorFn(propValue);

            if (iteratorFn) {
              var iterator = iteratorFn.call(propValue);
              var step;

              if (iteratorFn !== propValue.entries) {
                while (!(step = iterator.next()).done) {
                  if (!isNode(step.value)) {
                    return false;
                  }
                }
              } else {
                // Iterator will provide entry [k,v] tuples rather than values.
                while (!(step = iterator.next()).done) {
                  var entry = step.value;

                  if (entry) {
                    if (!isNode(entry[1])) {
                      return false;
                    }
                  }
                }
              }
            } else {
              return false;
            }

            return true;

          default:
            return false;
        }
      }

      function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === 'symbol') {
          return true;
        } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


        if (propValue['@@toStringTag'] === 'Symbol') {
          return true;
        } // Fallback for non-spec compliant Symbols which are polyfilled.


        if (typeof Symbol === 'function' && propValue instanceof Symbol) {
          return true;
        }

        return false;
      } // Equivalent of `typeof` but with special handling for array and regexp.


      function getPropType(propValue) {
        var propType = _typeof4(propValue);

        if (Array.isArray(propValue)) {
          return 'array';
        }

        if (propValue instanceof RegExp) {
          // Old webkits (at least until Android 4.0) return 'function' rather than
          // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
          // passes PropTypes.object.
          return 'object';
        }

        if (isSymbol(propType, propValue)) {
          return 'symbol';
        }

        return propType;
      } // This handles more types than `getPropType`. Only used for error messages.
      // See `createPrimitiveTypeChecker`.


      function getPreciseType(propValue) {
        if (typeof propValue === 'undefined' || propValue === null) {
          return '' + propValue;
        }

        var propType = getPropType(propValue);

        if (propType === 'object') {
          if (propValue instanceof Date) {
            return 'date';
          } else if (propValue instanceof RegExp) {
            return 'regexp';
          }
        }

        return propType;
      } // Returns a string that is postfixed to a warning about an invalid type.
      // For example, "undefined" or "of type array"


      function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);

        switch (type) {
          case 'array':
          case 'object':
            return 'an ' + type;

          case 'boolean':
          case 'date':
          case 'regexp':
            return 'a ' + type;

          default:
            return type;
        }
      } // Returns class name of the object, if any.


      function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) {
          return ANONYMOUS;
        }

        return propValue.constructor.name;
      }

      ReactPropTypes.checkPropTypes = checkPropTypes;
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(7));
  /***/
},
/* 107 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    /**
    * Copyright 2013-present, Facebook, Inc.
    * All rights reserved.
    *
    * This source code is licensed under the BSD-style license found in the
    * LICENSE file in the root directory of this source tree. An additional grant
    * of patent rights can be found in the PATENTS file in the same directory.
    */
    if (process.env.NODE_ENV !== 'production') {
      var invariant = __webpack_require__(33);

      var warning = __webpack_require__(47);

      var ReactPropTypesSecret = __webpack_require__(34);

      var loggedTypeFailures = {};
    }
    /**
     * Assert that the values match with the type specs.
     * Error messages are memorized and will only be shown once.
     *
     * @param {object} typeSpecs Map of name to a ReactPropType
     * @param {object} values Runtime values that need to be type-checked
     * @param {string} location e.g. "prop", "context", "child context"
     * @param {string} componentName Name of the component for error messages.
     * @param {?Function} getStack Returns the component stack.
     * @private
     */


    function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
      if (process.env.NODE_ENV !== 'production') {
        for (var typeSpecName in typeSpecs) {
          if (typeSpecs.hasOwnProperty(typeSpecName)) {
            var error; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.

            try {
              // This is intentionally an invariant that gets caught. It's the same
              // behavior as without this statement except with a better message.
              invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
              error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
            } catch (ex) {
              error = ex;
            }

            warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, _typeof4(error));

            if (error instanceof Error && !(error.message in loggedTypeFailures)) {
              // Only monitor this failure once because there tends to be a lot of the
              // same error.
              loggedTypeFailures[error.message] = true;
              var stack = getStack ? getStack() : '';
              warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
            }
          }
        }
      }
    }

    module.exports = checkPropTypes;
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(7));
  /***/
},
/* 108 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /**
   * Copyright 2013-present, Facebook, Inc.
   * All rights reserved.
   *
   * This source code is licensed under the BSD-style license found in the
   * LICENSE file in the root directory of this source tree. An additional grant
   * of patent rights can be found in the PATENTS file in the same directory.
   */

  var emptyFunction = __webpack_require__(32);

  var invariant = __webpack_require__(33);

  var ReactPropTypesSecret = __webpack_require__(34);

  module.exports = function () {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        // It is still safe when called from React.
        return;
      }

      invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    }

    ;
    shim.isRequired = shim;

    function getShim() {
      return shim;
    }

    ; // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.

    var ReactPropTypes = {
      array: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,
      any: shim,
      arrayOf: getShim,
      element: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim
    };
    ReactPropTypes.checkPropTypes = emptyFunction;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  /***/

},
/* 109 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = computeOffsetPixels;

  var _parseOffsetAsPercentage = __webpack_require__(110);

  var _parseOffsetAsPercentage2 = _interopRequireDefault(_parseOffsetAsPercentage);

  var _parseOffsetAsPixels = __webpack_require__(111);

  var _parseOffsetAsPixels2 = _interopRequireDefault(_parseOffsetAsPixels);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /**
   * @param {string|number} offset
   * @param {number} contextHeight
   * @return {number} A number representing `offset` converted into pixels.
   */


  function computeOffsetPixels(offset, contextHeight) {
    var pixelOffset = (0, _parseOffsetAsPixels2.default)(offset);

    if (typeof pixelOffset === 'number') {
      return pixelOffset;
    }

    var percentOffset = (0, _parseOffsetAsPercentage2.default)(offset);

    if (typeof percentOffset === 'number') {
      return percentOffset * contextHeight;
    }
  }

  module.exports = exports['default'];
  /***/
},
/* 110 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = parseOffsetAsPercentage;
  /**
   * Attempts to parse the offset provided as a prop as a percentage. For
   * instance, if the component has been provided with the string "20%" as
   * a value of one of the offset props. If the value matches, then it returns
   * a numeric version of the prop. For instance, "20%" would become `0.2`.
   * If `str` isn't a percentage, then `undefined` will be returned.
   *
   * @param {string} str The value of an offset prop to be converted to a
   *   number.
   * @return {number|undefined} The numeric version of `str`. Undefined if `str`
   *   was not a percentage.
   */

  function parseOffsetAsPercentage(str) {
    if (str.slice(-1) === '%') {
      return parseFloat(str.slice(0, -1)) / 100;
    }
  }

  module.exports = exports['default'];
  /***/
},
/* 111 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = parseOffsetAsPixels;
  /**
   * Attempts to parse the offset provided as a prop as a pixel value. If
   * parsing fails, then `undefined` is returned. Three examples of values that
   * will be successfully parsed are:
   * `20`
   * "20px"
   * "20"
   *
   * @param {string|number} str A string of the form "{number}" or "{number}px",
   *   or just a number.
   * @return {number|undefined} The numeric version of `str`. Undefined if `str`
   *   was neither a number nor string ending in "px".
   */

  function parseOffsetAsPixels(str) {
    if (!isNaN(parseFloat(str)) && isFinite(str)) {
      return parseFloat(str);
    } else if (str.slice(-2) === 'px') {
      return parseFloat(str.slice(0, -2));
    }
  }

  module.exports = exports['default'];
  /***/
},
/* 112 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (process) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = debugLog;

    function debugLog() {
      if (process.env.NODE_ENV !== 'production') {
        console.log(arguments); // eslint-disable-line no-console
      }
    }

    module.exports = exports['default'];
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(7));
  /***/
},
/* 113 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = ensureChildrenIsSingleDOMElement;

  var _react = __webpack_require__(31);

  var _react2 = _interopRequireDefault(_react);

  var _isDOMElement = __webpack_require__(114);

  var _isDOMElement2 = _interopRequireDefault(_isDOMElement);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /**
   * Raise an error if "children" isn't a single DOM Element
   *
   * @param {React.element|null} children
   * @return {undefined}
   */


  function ensureChildrenIsSingleDOMElement(children) {
    if (children) {
      _react2.default.Children.only(children);

      if (!(0, _isDOMElement2.default)(children)) {
        throw new Error('You must wrap any Component Elements passed to Waypoint in a DOM Element (eg; a <div>).');
      }
    }
  }

  module.exports = exports['default'];
  /***/
},
/* 114 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isDOMElement;
  /**
   * When an element's type is a string, it represents a DOM node with that tag name
   * https://facebook.github.io/react/blog/2015/12/18/react-components-elements-and-instances.html#dom-elements
   *
   * @param {React.element} Component
   * @return {bool} Whether the component is a DOM Element
   */

  function isDOMElement(Component) {
    return typeof Component.type === 'string';
  }

  module.exports = exports['default'];
  /***/
},
/* 115 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = getCurrentPosition;

  var _constants = __webpack_require__(48);

  var _constants2 = _interopRequireDefault(_constants);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /**
   * @param {object} bounds An object with bounds data for the waypoint and
   *   scrollable parent
   * @return {string} The current position of the waypoint in relation to the
   *   visible portion of the scrollable parent. One of `constants.above`,
   *   `constants.below`, or `constants.inside`.
   */


  function getCurrentPosition(bounds) {
    if (bounds.viewportBottom - bounds.viewportTop === 0) {
      return _constants2.default.invisible;
    } // top is within the viewport


    if (bounds.viewportTop <= bounds.waypointTop && bounds.waypointTop <= bounds.viewportBottom) {
      return _constants2.default.inside;
    } // bottom is within the viewport


    if (bounds.viewportTop <= bounds.waypointBottom && bounds.waypointBottom <= bounds.viewportBottom) {
      return _constants2.default.inside;
    } // top is above the viewport and bottom is below the viewport


    if (bounds.waypointTop <= bounds.viewportTop && bounds.viewportBottom <= bounds.waypointBottom) {
      return _constants2.default.inside;
    }

    if (bounds.viewportBottom < bounds.waypointTop) {
      return _constants2.default.below;
    }

    if (bounds.waypointTop < bounds.viewportTop) {
      return _constants2.default.above;
    }

    return _constants2.default.invisible;
  }

  module.exports = exports['default'];
  /***/
},
/* 116 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = onNextTick;
  var timeout = void 0;
  var timeoutQueue = [];

  function onNextTick(cb) {
    timeoutQueue.push(cb);

    if (!timeout) {
      timeout = setTimeout(function () {
        timeout = null; // Drain the timeoutQueue

        var item = void 0; // eslint-disable-next-line no-cond-assign

        while (item = timeoutQueue.shift()) {
          item();
        }
      }, 0);
    }

    var isSubscribed = true;
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;
      var index = timeoutQueue.indexOf(cb);

      if (index === -1) {
        return;
      }

      timeoutQueue.splice(index, 1);

      if (!timeoutQueue.length && timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
    };
  }

  module.exports = exports["default"];
  /***/
},
/* 117 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  /* WEBPACK VAR INJECTION */

  (function (global) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = resolveScrollableAncestorProp;

    function resolveScrollableAncestorProp(scrollableAncestor) {
      // When Waypoint is rendered on the server, `window` is not available.
      // To make Waypoint easier to work with, we allow this to be specified in
      // string form and safely convert to `window` here.
      if (scrollableAncestor === 'window') {
        return global.window;
      }

      return scrollableAncestor;
    }

    module.exports = exports['default'];
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(118));
  /***/
},
/* 118 */

/***/
function (module, exports) {
  var g; // This works in non-strict mode

  g = function () {
    return this;
  }();

  try {
    // This works if eval is allowed (see CSP)
    g = g || Function("return this")() || (1, eval)("this");
  } catch (e) {
    // This works if the window reference is available
    if ((typeof window === "undefined" ? "undefined" : _typeof4(window)) === "object") g = window;
  } // g can still be undefined, but nothing to do about it...
  // We return undefined, instead of nothing here, so it's
  // easier to handle this case. if(!global) { ...}


  module.exports = g;
  /***/
}]);